import {useEffect, useRef} from 'react';
import {Bugsnag} from '@shopify/react-bugsnag';
import {usePerformanceReport} from '@shopify/react-performance';
import {initiateAnalytics} from '../utils/monorail.client';
import {client} from '../config/bugsnag';
import {FeatureFlagsProvider} from 'shared/FeatureFlags/FeatureFlags';

import {Dux} from '@shopify/dux';

function InitiateAnalytics() {
  const didInitiateAnalytics = useRef(false);

  useEffect(() => {
    // https://github.com/reactwg/react-18/discussions/18#:~:text=Effects%20that%20should%20only%20run%20once%20can%20use%20a%20ref
    if (didInitiateAnalytics.current === false) {
      if (window.VERSION) {
        // eslint-disable-next-line no-console
        console.log(`Linkpop Release: Hydrogen ${window.VERSION}`);
      }

      initiateAnalytics();
      didInitiateAnalytics.current = true;
    }
  }, []);

  return null;
}

export default function ClientApp({
  children,
  queryString,
  countryCode,
  language,
  environment,
}) {
  const DUX_PATH = '/.well-known/dux';
  const eventHandlerEndpoint = ['production', 'staging'].includes(environment)
    ? DUX_PATH
    : `https://linkpop.com${DUX_PATH}`;

  usePerformanceReport('/performance_report');
  return (
    <Bugsnag client={client}>
      <FeatureFlagsProvider queryString={queryString}>
        <InitiateAnalytics />
        {children}
        <Dux
          service="linkpop"
          mode={environment}
          eventHandlerEndpoint={eventHandlerEndpoint}
          enableGtm={false}
          enableGtmLoader={false}
          emitTrekkiePageViewEvent={false}
          enableActiveConsent={false}
          countryCode={countryCode}
          locale={language}
        />
      </FeatureFlagsProvider>
    </Bugsnag>
  );
}
